// Leakbuster (ElevenLabs agent) config + secure conversation token from own backend
const API = `${process.env.REACT_APP_BACKEND_URL}/api/voice`;
let status = null;

export async function voiceStatus() {
  if (status) return status;
  try { status = await (await fetch(`${API}/status`)).json(); } catch { return {}; }
  return status;
}

export async function agentToken(agent = '', sid = '') {
  const own = localStorage.getItem('giss_owner_token');
  try { return (await (await fetch(`${API}/agent-token?agent=${agent}&sid=${sid}`, { headers: own ? { 'X-Owner-Token': own } : {} })).json()).token; } catch { return null; }
}
